import { render, staticRenderFns } from "./navbarTab.vue?vue&type=template&id=72e6f3e2&scoped=true&"
import script from "./navbarTab.vue?vue&type=script&lang=js&"
export * from "./navbarTab.vue?vue&type=script&lang=js&"
import style0 from "./navbarTab.vue?vue&type=style&index=0&id=72e6f3e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e6f3e2",
  null
  
)

export default component.exports